// Shared Eastern-time formatting for the smoke graphic (embed + social).

const AP_MONTHS = [
    'Jan.', 'Feb.', 'March', 'April', 'May', 'June',
    'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.',
];

function partsFor(date, opts) {
    return new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        ...opts,
    }).formatToParts(date);
}

const valueGetter = (parts) => (type) => parts.find((p) => p.type === type)?.value ?? '';

// e.g. "Mon., 3 p.m. ET" — used for the animated per-frame label.
export function formatET(date) {
    const get = valueGetter(partsFor(date, {
        weekday: 'short',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    }));
    const period = get('dayPeriod').toLowerCase().startsWith('p') ? 'p.m.' : 'a.m.';
    const minute = get('minute');
    const time = minute === '00' ? get('hour') : `${get('hour')}:${minute}`;
    return `${get('weekday')}., ${time} ${period} ET`;
}

// e.g. "Aug. 3, 2026, 12 p.m. EDT" — used for the "forecast as of" run time.
export function formatRunTime(date) {
    const get = valueGetter(partsFor(date, {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short',
    }));
    const month = AP_MONTHS[Number(get('month')) - 1];
    const period = get('dayPeriod').toLowerCase().startsWith('p') ? 'p.m.' : 'a.m.';
    const minute = get('minute');
    const time = minute === '00' ? get('hour') : `${get('hour')}:${minute}`;
    return `${month} ${get('day')}, ${get('year')}, ${time} ${period} ${get('timeZoneName')}`;
}
